import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OportunitiesService } from 'src/app/services/oportunities.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-delete-oport',
  templateUrl: './delete-oport.component.html',
  styleUrls: ['./delete-oport.component.scss']
})
export class DeleteOportComponent implements OnInit, OnDestroy {

  private subs = new SubSink();

  constructor(
    private snackBar: MatSnackBar,
    private trasnlateService: TranslateService,
    private oportunitieService: OportunitiesService,
    @Inject(MAT_DIALOG_DATA) public data: { idOport: string }
  ) { };


  ngOnDestroy(): void {
    this.subs.unsubscribe();
  };

  ngOnInit(): void { };

  private deleteOportunitie(id: string): void {
    this.subs.sink = this.oportunitieService.deleteOportunitie(id).subscribe()
  };

  public confirmDelete(): void {
    let change = true;
    this.subs.sink = this.trasnlateService.get(['OPORTUNITIES.deleted-success', 'USERS.undo']).subscribe((valor) => {
      const message = valor['OPORTUNITIES.deleted-success'];
      const action = valor['USERS.undo'];
      this.snackBar.open(message, action, {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top'
      });
      this.snackBar._openedSnackBarRef?.onAction().subscribe(() => {
        change = false;
      });

      this.snackBar._openedSnackBarRef?.afterDismissed().subscribe(() => {
        if (change === true) {
          this.deleteOportunitie(this.data.idOport);
        }
      });
    })
  }
}
